var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating2GrayOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9224 1.2063H1.92236V61.2063H61.9224V1.2063Z",
    stroke: "#797979",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3842 49.7709C47.3842 41.4836 40.5887 34.688 32.3014 34.688C24.0141 34.688 17.2185 41.4836 17.2185 49.7709C26.8318 45.13 37.9367 45.13 47.3842 49.7709Z",
    fill: "#797979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6993 27.8922C23.0793 27.8922 25.0087 25.9628 25.0087 23.5828C25.0087 21.2028 23.0793 19.2734 20.6993 19.2734C18.3193 19.2734 16.3899 21.2028 16.3899 23.5828C16.3899 25.9628 18.3193 27.8922 20.6993 27.8922Z",
    fill: "#797979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8979 16.6209C14.8979 16.6209 22.688 15.2949 27.4946 24.5767",
    stroke: "#797979",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2291 27.8922C47.6091 27.8922 49.5385 25.9628 49.5385 23.5828C49.5385 21.2028 47.6091 19.2734 45.2291 19.2734C42.8491 19.2734 40.9197 21.2028 40.9197 23.5828C40.9197 25.9628 42.8491 27.8922 45.2291 27.8922Z",
    fill: "#797979"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0303 16.6209C51.0303 16.6209 43.2402 15.2949 38.4336 24.5767",
    stroke: "#797979",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating2GrayOutlined);
export default __webpack_public_path__ + "static/media/rating2-gray-outlined.0e0383cebffc5b4739b4333143b34c8c.svg";
export { ForwardRef as ReactComponent };